<!-- Template for sudo button -->
<ng-template #sudoBtn let-clickHandler="clickHandler" let-condition="condition">
    <button class="btn btn-marine-blue ml-1"
            [ngClass]="{'btn-disabled-grey': isApiUser()}"
            [disabled]="isApiUser()"
            (click)="!isApiUser() && clickHandler()"
            *ngIf="condition">
        <mon-icon [styles]="{'margin-right': '5px'}" [icon]="['USERS', 'SUDO']"></mon-icon>
        <span *ngIf="!isApiUser()" translate>Sudo as user</span>
        <span *ngIf="isApiUser()" translate>API user - sudo unavailable</span>
    </button>
</ng-template>

<!-- Scenario 1: Customer input provided -->
<ng-container *ngTemplateOutlet="sudoBtn; context: {
    clickHandler: sudoWithCustomer,
    condition: customer
}"></ng-container>

<!-- Scenario 2: Single customer agreement -->
<ng-container *ngTemplateOutlet="sudoBtn; context: {
    clickHandler: sudoWithFirstAgreement,
    condition: !customer && customerAgreements().length === 1
}"></ng-container>

<!-- Scenario 3: Multiple customer agreements - Dropdown for regular users -->
<mon-table-dropdown title="{{ 'Sudo as user' | translate }}"
                *ngIf="customerAgreements().length > 1 && !isApiUser()">
    <ng-container *ngFor="let agreement of user.user_agreements">
        <li ngbDropdownItem role="menuitem" *ngIf="agreement.account.type === 'Customer'" >
            <a (click)="sudo(agreement.account.id, user)"
               href="#"
               role="button"
               class="cursor-pointer">
                <mon-icon [styles]="{'margin-right': '5px'}" [icon]="['USERS', 'SUDO']"></mon-icon>
                <span>{{ agreement.account.name }}</span>
            </a>
        </li>
    </ng-container>
</mon-table-dropdown>

<!-- Scenario 3: Multiple customer agreements - Disabled button for API users -->
<button class="btn btn-marine-blue ml-1 btn-disabled-grey"
        disabled
        *ngIf="customerAgreements().length > 1 && isApiUser()">
    <mon-icon [styles]="{'margin-right': '5px'}" [icon]="['USERS', 'SUDO']"></mon-icon>
    <span translate>API user - sudo unavailable</span>
</button>
